var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getHasContent)?_c('div',{staticClass:"richtext-container",class:_vm.baseClass || 'text-body'},[_c('div',{attrs:{"itemprop":"text"}},[_c('RichTextRenderer',{attrs:{"document":_vm.getMappedContent,"nodeRenderers":_vm.renderNodes()}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }